import { LibraryThing } from "../ls2pac/widget/LibraryThingWidget";

export class ListPreloader {
  constructor(options) {
    this.destroyed = false;
    this.list = options.list;
    this.getPageRetry = 1000;
    this.domainCount = 3; //the number of content server urls we request from
    this.requestPerURL = 4; //the number of concurrent requests per domain
    this.doneLoading = false;
    this.attempted = 0;
    this.imageTimeout = 4000; //the longest I have seen a request from the content server take is 3.80s
    this.init();
  }
  destroy(){
    this.destroyed = true;
  }
  getPageCount() {
    return $.grep(this.list, function (resource, i) {
      return resource.loaded !== false;
    }).length;
  }
  getPossibleRemaining() {
    return $.grep(this.list, function (resource, i) {
      return resource.loaded !== false && resource.consumed !== true;
    });
  }
  getAvailable() {
    return $.grep(this.list, function (resource, i) {
      return resource.loaded === true && resource.consumed !== true;
    });
  }
  getConsumed() {
    return $.grep(this.list, function (resource, i) {
      return resource.consumed === true;
    });
  }
  getFailed() {
    return $.grep(this.list, function (resource, i) {
      return resource.loaded === false;
    });
  }
  isDoneLoading() {
    return this.doneLoading;
  }
  getRemaining() {
    return $.grep(this.list, function (resource, i) {
      return resource.loaded === undefined;
    });
  }
  getLoadCounts() {
    var available = this.getAvailable().length;
    var possibleRemaining = this.getRemaining().length;
    var consumed = this.getConsumed().length;
    var failed = this.getFailed().length;
    var total = this.list.length;
    if (possibleRemaining === 0) {
      this.doneLoading = true;
    } else {
      this.doneLoading = false;
    }
    return {
      attempted: this.attempted,
      available: available,
      possibleRemaining: possibleRemaining,
      consumed: consumed,
      failed: failed,
      doneLoading: this.isDoneLoading(),
      possibleTotal: available + possibleRemaining + consumed,
      total: total,
    };
  }
  init() {
    var totalRequests = this.domainCount * this.requestPerURL,
      startingResources = this.list.slice(0, totalRequests),
      _this = this;

    $.each(startingResources, function (i, resource) {
      _this.loadJacket(resource);
    });
  }
  loadJacket(resource) {
    this.attempted++;
    var jacketURL = this.getJacketURL(resource),
      _this = this;
    var imgTimeout = setTimeout(function () {
      if (_this.destroyed) return;
      _this.onImageTimeout(resource);
    }, this.imageTimeout);
    $("<img/>") //Make an in memory copy to avoid css issues
    .on("load", function () {
        if(_this.destroyed) return;
        clearTimeout(imgTimeout);
        // this refers to the loaded image
        /* eslint-disable no-invalid-this */
        if (this.height > 1 && this.width > 1) {
          resource.jacketURL = jacketURL;
          /* eslint-disable no-invalid-this */
          _this.onLoad(this, resource);
        } else {
          _this.onImageNotFound(resource);
          //There is no image on the content server
        }
      })
      .on("error", function () {
        if(_this.destroyed) return;
        clearTimeout(imgTimeout);
        _this.onError(resource);
      })
      .attr("src", jacketURL);
  }
  getJacketURL(resource) {
    var jacketSize = LibraryThing.enums.requestType.bookJacketLarge,
      srcUrl = LibraryThing.getBookjacketUrl(jacketSize, resource);
    //TODO does this automatically cycle through content servers?
    return srcUrl;
  }
  loadNextImage() {
    if(this.destroyed) return;
    //TODO use the same content server url as the one that just finished
    const nextResource = this.list.slice(this.attempted, this.attempted + 1);
    if (nextResource.length > 0) {
      this.loadJacket(nextResource[0]);
    } else {
      this.doneLoading = true;
    }
  }
  onLoad(img, resource) {
    resource.loaded = true;
    resource.realWidth = img.width;
    resource.realHeight = img.height;
    this.loadNextImage();
  }
  onError(resource) {
    resource.loaded = false;
    this.loadNextImage();
    //TODO build in retry
  }
  onImageNotFound(resource) {
    resource.loaded = false;
    this.loadNextImage();
    //don't need to retry, content server sent a 1x1 image
  }
  onImageTimeout(resource) {
    resource.loaded = false;
    this.loadNextImage();
    //TODO build in retry
  }
  setConsumedAndCallback(resources, callback) {
    $.each(resources, function (i, resource) {
      resource.consumed = true;
    });
    callback(resources);
  }
  getPage(pageSize, callback) {
    var loadedResources = this.getAvailable(),
      _this = this;
    if (loadedResources.length >= pageSize) {
      var resources = loadedResources.slice(0, pageSize);
      //grab the first pageSize worth
      this.setConsumedAndCallback(resources, callback);
    } else if (this.getRemaining().length === 0) {
      //we've loaded everything, return what's left
      this.doneLoading = true;
      this.setConsumedAndCallback(loadedResources, callback);
    } else {
      //try again in a bit
      setTimeout(function () {
        if (_this.destroyed) return;
        _this.getPage(pageSize, callback);
      }, this.getPageRetry);
    }
  }
}
